import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Textarea,
} from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";

interface CommonFormFieldProps {
  name: string;
  control: any;
  label: string;
  placeholder?: string;
  rules?: any;
  type?: "input" | "textarea";
  rows?: number;
  [key: string]: any;
}

const CommonInputField: React.FC<CommonFormFieldProps> = ({
  name,
  control,
  label,
  placeholder,
  rules,
  type = "input",
  rows,
  ...rest
}) => {
  const {
    formState: { errors },
  } = useFormContext();
  const error = errors[name];
  const errorMessage =
    typeof error === "object" && error !== null ? error.message : undefined;

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) =>
          type === "textarea" ? (
            <Textarea
              {...field}
              placeholder={placeholder}
              width="100%"
              bg="#FFF"
              color="#2F2F34"
              fontWeight={400}
              borderColor={error ? "#E53E3E" : "#CDD6DC"}
              borderRadius="md"
              rows={rows || 6}
              _focus={{
                borderColor: error ? "#E53E3E" : "#1819B4",
                boxShadow: "none",
              }}
              _active={{
                borderColor: error ? "#E53E3E" : "#1819B4",
                boxShadow: "none",
              }}
              _hover={{ borderColor: error ? "#E53E3E" : "#1819B4" }}
              minHeight="100px"
              {...rest}
            />
          ) : (
            <Input
              {...field}
              placeholder={placeholder}
              borderColor={error ? "#E53E3E" : "#CDD6DC"}
              bg="#FFF"
              color="#2F2F34"
              fontWeight={400}
              borderRadius="md"
              height={"40px"}
              _focus={{
                borderColor: error ? "#E53E3E" : "#1819B4",
                boxShadow: "none",
              }}
              _active={{
                borderColor: error ? "#E53E3E" : "#1819B4",
                boxShadow: "none",
              }}
              _hover={{ borderColor: error ? "#E53E3E" : "#1819B4" }}
              {...rest}
            />
          )
        }
      />
      <FormErrorMessage>
        {typeof errorMessage === "string" ? errorMessage : null}
      </FormErrorMessage>
    </FormControl>
  );
};

export default CommonInputField;
